var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2957 0.316166C25.5383 -0.226828 24.4842 -0.0530648 23.9411 0.704287L8.15186 22.7181L2.88128 17.443C2.45505 17.0166 1.83369 16.8499 1.25126 17.0058C0.668837 17.1618 0.213833 17.6165 0.057646 18.1989C-0.0985415 18.7812 0.0678156 19.4027 0.494052 19.8291L7.17087 26.5048C7.52547 26.846 8.00952 27.0186 8.5 26.9785C8.99048 26.9385 9.44015 26.6898 9.73472 26.2956L26.6838 2.67077C27.2268 1.91338 27.0531 0.859214 26.2957 0.316166Z",
    fill: "#2D9CDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCheckMark);
export default __webpack_public_path__ + "static/media/blue-check-mark.ecd975fa.svg";
export { ForwardRef as ReactComponent };